export default "__VITE_ASSET__53fccd2c__"